module.exports = __webpack_public_path__ + "science.28adde7035b5f1a64c26.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/science/webfont/science.svg
// module id = ../../../../../src/assets/fonts/line-icons-pro/science/webfont/science.svg
// module chunks = styles